/**
 * Used to represent the data
 * for a component to open
 */
import {ComponentFactoryResolver} from '@angular/core';

export class SubContentModel {
	public componentFactoryResolver: ComponentFactoryResolver;
	public component: any;
	public data: any;
}

/**
 * Helps to know when the panel is open, or close
 */
export enum SubContentEventType {
	OPEN_CLOSE = 'sub-content-type-open-close',
}
